"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.singleFilter = singleFilter;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const BaseFilter_1 = require("./BaseFilter");
const SelectField_1 = require("../../inputs/SelectField");
function singleFilter(props) {
    return (key) => new SingleFilter(key, props);
}
// Make an option that we'll sneak into every select field
const allOption = {};
class SingleFilter extends BaseFilter_1.BaseFilter {
    render(value, setValue, tid, inModal, vertical) {
        const { label, defaultValue, options: maybeOptions, getOptionLabel, getOptionValue, nothingSelectedText, ...props } = this.props;
        const options = Array.isArray(maybeOptions)
            ? [allOption, ...maybeOptions]
            : { ...maybeOptions, current: maybeOptions.current };
        return ((0, jsx_runtime_1.jsx)(SelectField_1.SelectField, { ...props, options: options, getOptionValue: (o) => (o === allOption ? undefined : getOptionValue(o)), getOptionLabel: (o) => (o === allOption ? (nothingSelectedText !== null && nothingSelectedText !== void 0 ? nothingSelectedText : "All") : getOptionLabel(o)), compact: !vertical, value: value, label: this.label, labelStyle: inModal ? "hidden" : !inModal && !vertical ? "inline" : "above", sizeToContent: !inModal && !vertical, nothingSelectedText: nothingSelectedText !== null && nothingSelectedText !== void 0 ? nothingSelectedText : "All", onSelect: (value) => setValue(value || undefined), ...this.testId(tid) }));
    }
}
